<template lang="pug">
.faq
	h1 Часто задаваемые вопросы
	.faq__item(v-for="item in items")
		.faq__item-question-wrap
			.faq__item-question
				vue-markdown {{item.faqQuestion}}
		.faq__item-answer-wrap
			.faq__item-answer
				vue-markdown {{item.faqAnswer}}
</template>
<script>
import { mapGetters } from "vuex";
import VueMarkdown from 'vue-markdown'
export default {
	name: "home",
	computed: {
		...mapGetters({
			items: "main/faqItems",
			loading: "main/loading",
			loaded: "main/loaded"
		})
	},
	data() {
		return {
		
		}
	},		
	methods: {},
	components: {
		VueMarkdown,
	}
}

</script>

<style lang="stylus">
.faq
	max-width 1000px
	margin 0 auto
	padding 30px 20px
	&__item
		margin-bottom: 40px
		&-question
			text-align: left
			min-width: 20%
			max-width 70%
			padding 20px 35px
			background-color #eee
			display inline-block
			border-radius 5px
			margin 0 0 10px 0
			overflow hidden

		&-answer
			text-align: left
			min-width: 20%
			max-width 70%
			padding 20px 35px
			background-color #764184
			color white
			display inline-block
			border-radius 5px
			overflow hidden


			a
				color #efb2ff
			

			&-wrap
				text-align right

</style>